import React, { useContext, useState } from "react";

import { FormProvider, useFieldArray, useForm } from "react-hook-form";

import CuePointsPlayer from "./cuePoints/CuePointsPlayer";
import CuePointsTable from "./cuePoints/CuePointsTable";
import ContentContext from "../../contexts/ContentContext";

import type { JSX } from "react";

import type { GetMediaResponse, MediaUpdated } from "../../api/MediaAPI.types";

interface CuepointForm {
  enabled: boolean;
  timecode: string;
  uuid?: string;
}

export interface CuepointsFormValues {
  cuepoints: CuepointForm[];
}

function TabContentCuePoints(): JSX.Element {
  const { item, onItemUpdate } = useContext<{
    item: GetMediaResponse;
    onItemUpdate: (media: MediaUpdated) => void;
  }>(ContentContext);

  const formValueCuepoints = item.cuepoints.map((cuepoint) => ({
    enabled: cuepoint.enabled,
    timecode: cuepoint.timecode,
    uuid: cuepoint.uuid,
  }));

  const [formValues, setFormValues] = useState<CuepointsFormValues>({
    cuepoints: formValueCuepoints,
  });

  const methods = useForm<CuepointsFormValues>({
    mode: "all",
    defaultValues: formValues,
  });

  const fieldArray = useFieldArray({
    control: methods.control,
    name: "cuepoints",
  });

  return (
    <div className="@container/cuepoints flex flex-wrap items-stretch gap-6.25">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FormProvider {...methods}>
        <div className="flex grow-5 basis-140">
          <CuePointsPlayer fieldArray={fieldArray} item={item} />
        </div>
        <div className="relative min-h-80 grow basis-120 @max-[1065px]/cuepoints:min-h-125">
          <CuePointsTable
            fieldArray={fieldArray}
            formValues={formValues}
            item={item}
            onItemUpdate={onItemUpdate}
            setFormValues={setFormValues}
          />
        </div>
      </FormProvider>
    </div>
  );
}

export default TabContentCuePoints;
